export default __webpack_public_path__ + "static/media/i_l.d191a6b2.wav";